(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('WebhookStatusFactory', WebhookStatusFactory);

    WebhookStatusFactory.$inject = ['$resource'];

    function WebhookStatusFactory($resource) {
        var resourceUrl = 'flyer/api/webhook/error-status';

        return $resource(resourceUrl, {}, {
            'getErrorStatus': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();
